import Calendar from '@/api/calendar'

export const state = {
  events: []
}

export const getters = {}

export const mutations = {
  RECEIVE_EVENTS(state, data) {
    state.events = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = attributes
    return Calendar.get({ params }).then(response => {
      context.commit('RECEIVE_EVENTS', response.data)
    })
  },
  fetchEvent(context, attributes = {}) {
    const params = attributes
    return Calendar.get({ params }).then(response => {
      return Promise.resolve(response)
    })
  }
}
